import { isFeatureEnabled } from "./VelocityApi";
import { tryGetHostApi } from "./externalApi";
export async function deleteContainerAsync(storageContainer) {
    if (await isFeatureEnabled("Feature_HeaderStorageApi")) {
        const headerStorageApi = await tryGetHostApi("HeaderStorage", 1, 1);
        if (headerStorageApi) {
            headerStorageApi.deleteContainer(storageContainer);
        }
    }
}
export async function deleteHeaderAsync(storageContainer, storageKey) {
    if (await isFeatureEnabled("Feature_HeaderStorageApi")) {
        const headerStorageApi = await tryGetHostApi("HeaderStorage", 1, 1);
        if (headerStorageApi) {
            headerStorageApi.deleteHeader(storageContainer, storageKey);
        }
    }
}
export async function getAllHeadersInfoAsync(storageContainer) {
    if (await isFeatureEnabled("Feature_HeaderStorageApi")) {
        const headerStorageApi = await tryGetHostApi("HeaderStorage", 1, 1);
        if (headerStorageApi) {
            return await headerStorageApi.getAllHeadersInfo(storageContainer);
        }
    }
    return "";
}
export async function getHeaderInfoAsync(storageContainer, storageKey) {
    if (await isFeatureEnabled("Feature_HeaderStorageApi")) {
        const headerStorageApi = await tryGetHostApi("HeaderStorage", 1, 1);
        if (headerStorageApi) {
            return await headerStorageApi.getHeaderInfo(storageContainer, storageKey);
        }
    }
    return "";
}
export async function isMigrationCompleteAsync(storageKey) {
    if (await isFeatureEnabled("Feature_HeaderStorageApi")) {
        const headerStorageApi = await tryGetHostApi("HeaderStorage", 1, 1);
        if (headerStorageApi) {
            return await headerStorageApi.isMigrationComplete(storageKey);
        }
    }
    return false;
}
export async function setHeaderInfoAsync(storageContainer, storageKey, widgetPinnedInfo) {
    if (await isFeatureEnabled("Feature_HeaderStorageApi")) {
        const headerStorageApi = await tryGetHostApi("HeaderStorage", 1, 1);
        if (headerStorageApi) {
            headerStorageApi.setHeaderInfo(storageContainer, storageKey, widgetPinnedInfo);
        }
    }
}
